import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IGlobalSearchParam } from '../../../app/shared/models/Global-Search.model';
import { ApiService } from '../../../app/shared/services';
import { IClientCheckLists } from '../models';

@Injectable({
  providedIn: 'root'
})
export class ClientCheckListsService {

  constructor(
    private http: HttpClient,
    private apiService: ApiService
  ) { }

  getClientCheckLists(searchParam:IGlobalSearchParam):Observable<any>{
      return this.apiService.post(`ClientCheckLists/SearchClientCheckLists`,searchParam)
  }

  getClientCheckListIndividual(checkListId:number):Observable<any> {
    return this.apiService.getInd(`ClientCheckLists/${checkListId}`)
  }

  deleteClientCheckListsDetail(checkListId:number):Observable<any> {
    return this.apiService.delete(`ClientCheckLists/${checkListId}`)
  }

  getVendorCompanyList():Observable<any>{
    return this.apiService.get(`CompanyProfile/AllApprovedCompanyList`);
  }

  getClientCompanyList():Observable<any>{
    return this.apiService.get(`CompanyProfile/ClientCompanyList`);
  }

  postClientCheckLists(clientCheckLists: IClientCheckLists): Observable<any> {
    return this.apiService.post(`ClientCheckLists/PostClientCheckLists`, clientCheckLists)
  }

  public updateClientCheckLists(checkListId:number, clientCheckLists:IClientCheckLists):Observable<any> {
    return this.apiService.put(`ClientCheckLists/${checkListId}`, clientCheckLists)
    }

  getClientCheckListsByClientId(clientCompanyId: number):Observable<any>{
    return this.apiService.get(`ClientCheckLists/ClientCheckListsByClientId/${clientCompanyId}`);
  }

  getClientCheckListsByClientName(clientCompanyName: string):Observable<any>{
    return this.apiService.get(`ClientCheckLists/ClientCheckListsByClientName/${clientCompanyName}`);
  }



}
